export default __webpack_public_path__ + "static/media/12.b511c46d.PNG";